module.exports = __webpack_public_path__ + "static/media/icon.56763399.png";